import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

export interface McpLoginHandoffResponse {
  redirectUrl: string;
}

/**
 * Confirms to the Opsium MCP authorization server that the signed-in user is connecting an AI app.
 * @param nonce - The `nonce` query parameter the connect page was opened with
 * @returns The backend URL to send the browser to, which shows the consent screen
 */
export const createMcpLoginHandoff = async (nonce: string): Promise<string> => {
  const endpoint = '/api/mcp/login-handoffs';

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.CONNECT_AI_FAILED, () =>
    axiosInstance.post<ApiResponse<McpLoginHandoffResponse>>(endpoint, { nonce })
  );

  return response.redirectUrl;
};
